import colors from '@nykaa/ui-components/tokens/colors';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

export const theme = {
  colors: {
    primary: colors.pebble900,
    primary10: colors.pebble100,
    primary20: colors.pebble200,
    primary30: colors.pebble400,
    primary40: colors.pebble600,
    primary50: colors.pebble700,

    surface: colors.snow100,
    surface10: colors.snow200,
    surface20: colors.snow300,
    surface30: colors.snow500,
    surface40: colors.snow600,
    surface50: colors.snow200,

    secondary: '#A61C54',
    secondary10: '#FDF2F6',
    secondary20: '#FBE5EE',
    secondary30: '#C42163',
    secondary40: '#7A153E',
    secondary50: '#570F2C',
    sellerInfoText: '#A61C54',

    inverse: colors.black100,
    inverse10: colors.black700,
    inverse20: colors.black600,
    inverse30: colors.black500,
    inverse40: colors.black400,
    inverse50: colors.black300,

    info: colors.blue600,
    // Note: value of blue50 is "#e6f2ff" rather than #E7F2FF
    info10: colors.blue50,

    pdpTagColor: colors.blue600,

    stateHover: hexToRgb(colors.snow600, 0.08),
    statePressed: hexToRgb(colors.snow600, 0.16),
    stateDisabled: hexToRgb(colors.snow600, 0.36),

    textPrimary: colors.pebble800,
    textSecondary: hexToRgb(colors.pebble800, 0.72),
    textOutline: hexToRgb(colors.black100, 0.16),
    textDecorative: hexToRgb(colors.black100, 0.08),
    textDisabled: colors.pebble300,
    textInversePrimary: colors.snow100,

    surfaceInverse: colors.black100,
    surfaceInverse10: colors.black600,
    surfaceInverse20: colors.black500,
    surfaceInverse30: colors.black400,
    surfaceInverse40: colors.black300,
    surfaceInverse50: colors.black200,

    state: colors.snow600,
    menuItemHover: '#A61C54',
    viewBagColor: '#A61C54',
    hnmTabActiveColor: '#E50010',
    hnmTabInactiveColor: '#596875',

    positivePrimary: colors.green700,
    negativePrimary: colors.red700,
    negative10: colors.red50,
    negativeOpacity8: hexToRgb(colors.red700, 0.08),
    negativeOpacity16: hexToRgb(colors.red700, 0.16),

    warningPrimary: colors.orange700,
    warning10: colors.orange50,
    warningOpacity8: hexToRgb(colors.orange600, 0.08),
    warningOpacity16: hexToRgb(colors.orange600, 0.16),

    filterSurface: colors.snow100,
    filterHover: '#FDF2F6',
    filterSelected: '#FDF2F6',
    filterBackdropFilter: '0',
    reviewTagBackground: colors.snow200,
    searchTextColor: hexToRgb(colors.pebble800, 0.72),
    searchBgColor: colors.snow300,
    searchSectionBgColor: colors.snow300,
    searchTermBorderColor: colors.snow300,
    suggestionIconColor: hexToRgb(colors.pebble900, 0.4),
    overlayBg: colors.snow100,
    brandbookTagBg: colors.snow300,
    brandbookBrandTagBg: colors.black100,
    brandbookBrandTagTextColor: colors.snow100,
    brandReviewBg: colors.snow200,
    brandReviewTag: colors.snow100,
    wishlistIconBg: colors.snow100,
    mwebFilterBg: colors.snow200,
    mwebFilterSelected: colors.snow100,
    sizeSelected: colors.pebble900,
    ratingBg: 'transparent',
    subtextColor: colors.pebble900,
    sizeGuideColor1: colors.snow300,
    sizeGuideBorder: 'transparent',
    sizeGuidePillBg: 'transparent',
    sizeGuideToggleBg: '#FDF2F6',
    sizeGuideToggleOutline: '#A61C54',
    pdpCouponsSectionBg: colors.snow100,
    pdpCouponBgImgOpacity: 1,
    pdpCavSectionBg: "#f3f4f5",
    filterInputBg: colors.snow300,
    eddInputBg: colors.snow300,
    eddInputFocus: colors.snow300,
    responsibleTagBg: 'rgba(0, 137, 69, 0.12)',
    shimmerBg: colors.snow300,
    wishlistNudge: colors.black300,
    brand_primary: '#fd7685',
    sectionBg: colors.snow300,
    copyrightBg: '#A61C54',
    modelDetailsBg: colors.snow200,
    modelDetailsBorder: hexToRgb(colors.black100, 0.08),
    modelDetailsCardBg: '#d6d9dc',
    modelDetailsSecondCardBg: hexToRgb(colors.black100, 0.08),
    policyCardBg: colors.snow200,
  },
  borders: {
    buttonBorderRadius: '0px',
    mwebButtonBorderRadius: '2px',
  },
  typography: {},
};
